import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

function useCommonConfig() {
  const { cb, key } = fetch();
  const { data, isLoading, isSuccess, isError, refetch } = useQuery(key, cb, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    cacheTime: Infinity,
  });

  return { data, isLoading, isSuccess, isError, refetch };
}

export { useCommonConfig };
export default { useCommonConfig };
